import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { FooterItem } from '.';

export const useSettingList = () => {
  const { t } = useTranslation();
  const { home } = useStore();
  const { confList } = home;

  const {
    user_agreemen,
    help_center,
    disclaimer,
    risk_tips,
    about_us,
    privacy,
    cooperation,
  } = confList;

  const produceList = [
    // { title: t('footer.appDl'), url: larding_page_url },
    { title: t('footer.spot'), url: '/spot/trade/btc_usdt' },
    // { title: t('footer.futures'), url: '/futures/contract/u_based/btc_usdt' },
    // { title: t('footer.copyTrade'), url: `/${lang}/copy-trading/futures` },
    // { title: t('footer.crypto'), url: '/account/otc/index' },
    // { title: t('footer.help'), url: help_center },
  ];
  const aboutUsList = [
    { title: t('footer.userAgreement'), url: user_agreemen },
    { title: t('footer.privacyPolicy'), url: privacy },
    { title: t('footer.disclaimer'), url: disclaimer },
    // { title: t('footer.verifyChannal'), url: verification_channel },
    { title: t('footer.risk_tips'), url: risk_tips },
  ];
  const introduceList = [
    { title: t('footer.help'), url: help_center },
    { title: t('footer.aboutUs'), url: about_us },

    // { title: t('footer.ticket'), url: work_order },
    { title: t('footer.business'), url: cooperation },
  ];
  return useMemo<FooterItem[]>(
    () => [
      {
        title: t('footer.aboutUs'),
        children: aboutUsList,
      },
      {
        title: t('footer.technicalSupport'),
        children: produceList,
      },

      {
        title: t('footer.termsInfo'),
        children: introduceList,
      },
    ],
    [t, produceList, introduceList, aboutUsList],
  );
};
